<div class="header-container">
    <div class="main-header">
        Account management
    </div>
    <div class="tabs-container">
        <ng-container *ngFor="let tab of tabs; let i = index; let last = last">
          <div class="tab" [ngClass]="{ 'active': activeTab === tab }" (click)="switchTab(tabs[i])">
            {{ tab }}
          </div>
          <div *ngIf="!last" class="tab separator">|</div>
        </ng-container>
      </div>
</div>
<div class="main-container">
    <div class="top-container">
      <app-search-bar (onSubmitSearch)="search()" [searchControl]="searchTerm"></app-search-bar>
      <app-button [text]="activeButtonText" class="primary" (clicked)="tabConfigs[activeTab].add()"></app-button>
    </div>
    <router-outlet></router-outlet>
    <div class="bottom-container">
      <app-paginator [length]="totalRecords" [pageSize]="pageSize" [initialPage]="initialPage" (page)="onPageChange($event)"></app-paginator>
    </div>
</div>
